module.exports = __webpack_public_path__ + "img/1.6_Russian_road_sign.1c63d1ab.svg";